export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81')
];

export const server_loads = [];

export const dictionary = {
		"/": [8],
		"/about": [10],
		"/history": [11],
		"/network-tools": [12,[2]],
		"/network-tools/broken-link-checker": [13,[2]],
		"/network-tools/dns-lookup": [14,[2]],
		"/network-tools/http-status": [15,[2]],
		"/network-tools/memory-usage-tracker": [16,[2]],
		"/network-tools/meta-tag-analyzer": [17,[2]],
		"/network-tools/mx-record-checker": [18,[2]],
		"/network-tools/page-load-time-tester": [19,[2]],
		"/network-tools/ping": [20,[2]],
		"/network-tools/ssl-certificate-checker": [21,[2]],
		"/network-tools/website-status-checker": [22,[2]],
		"/network-tools/what-is-my-ip-address": [~23,[2]],
		"/privacy-policy": [24],
		"/screensaver": [25,[3]],
		"/screensaver/black-screen": [26,[3]],
		"/screensaver/blue-screen": [27,[3]],
		"/screensaver/brown-screen": [28,[3]],
		"/screensaver/clock-screen": [29,[3]],
		"/screensaver/cyan-screen": [30,[3]],
		"/screensaver/gray-screen": [31,[3]],
		"/screensaver/green-screen": [32,[3]],
		"/screensaver/lime-screen": [33,[3]],
		"/screensaver/orange-screen": [34,[3]],
		"/screensaver/pink-screen": [35,[3]],
		"/screensaver/purple-screen": [36,[3]],
		"/screensaver/red-screen": [37,[3]],
		"/screensaver/time-screen": [38,[3]],
		"/screensaver/white-screen": [39,[3]],
		"/screensaver/yellow-screen": [40,[3]],
		"/share": [41],
		"/terms-and-conditions": [42],
		"/time-management": [43,[4]],
		"/time-management/countdown": [44,[4]],
		"/time-management/day-of-the-year-calculator": [45,[4]],
		"/time-management/event-countdown-generator": [46,[4]],
		"/time-management/event-countdown-generator/event": [47,[4,5]],
		"/time-management/interval-timer": [48,[4]],
		"/time-management/pomodoro-timer": [49,[4]],
		"/time-management/reminder": [50,[4]],
		"/time-management/stopwatch": [51,[4]],
		"/time-management/sunrise-sunset-countdown": [52,[4]],
		"/time-management/time-spent-tracker": [53,[4]],
		"/time-management/time-spent-tracker/activities": [54,[4]],
		"/time-management/time-spent-tracker/activities/report": [55,[4]],
		"/time-management/time-spent-tracker/log": [56,[4]],
		"/time-management/time-spent-tracker/summary": [57,[4]],
		"/time-management/timezone-lookup": [58,[4]],
		"/time-management/to-do-list": [59,[4,6]],
		"/time-management/to-do-list/addsubtask/[taskId]": [61,[4,6]],
		"/time-management/to-do-list/add": [60,[4,6]],
		"/time-management/to-do-list/comments": [62,[4,6]],
		"/time-management/to-do-list/destroy": [63,[4,6]],
		"/time-management/to-do-list/details/[taskId]": [64,[4,6]],
		"/time-management/to-do-list/due-dates": [65,[4,6]],
		"/time-management/to-do-list/export-tasks": [66,[4,6]],
		"/time-management/to-do-list/how-to-use": [67,[4,6]],
		"/time-management/to-do-list/import-tasks": [68,[4,6]],
		"/time-management/to-do-list/tags": [69,[4,6]],
		"/time-management/to-do-list/track-time": [70,[4,6]],
		"/time-management/unix-timestamp": [71,[4]],
		"/time-management/world-clocks": [72,[4]],
		"/time-management/world-time-finder": [73,[4]],
		"/utilities": [74,[7]],
		"/utilities/cookie-manager": [75,[7]],
		"/utilities/erlang-calculator": [76,[7]],
		"/utilities/microphone-test": [77,[7]],
		"/utilities/name-picker": [78,[7]],
		"/utilities/paycheck-calculator": [79,[7]],
		"/utilities/random-security-check": [80,[7]],
		"/utilities/webcam-tester": [81,[7]],
		"/[...catchall]": [9]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';